/**
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: valeriaplutino
 * Created: 9/12/21
 */

import React from 'react';
import { Flex, Text } from '@chakra-ui/react';

interface MetricsBoxProps {
    value: string;
}

export const MetricsBox = (props: MetricsBoxProps) => {
    return (
        <Flex
            bg="gray.100"
            rounded="20%"
            w={{ base: '100px', md: '150px', lg: '125px' }}
            h={{ base: '100px', md: '150px', lg: '125px' }}
            alignItems="center"
            justifyContent="center"
        >
            <Text
                fontWeight="bold"
                fontSize={{ base: '2xl', md: '3xl' }}
                color="blue.500"
                textAlign="center"
                whiteSpace="nowrap"
                role="text"
                as="p"
            >
                {props.value}
            </Text>
        </Flex>
    );
};
